import { Ref } from '@/decorators/ref';
import { assignOwnProperties } from '@/utils/assignOwnProperties';
import { normalize } from '@/utils/normalize';
import type { IVehiclePosition } from '~/api/IVehiclePosition';

export class VehiclePosition {
  // Primary key used by VehiclePositionStore.
  @Ref vehicleId: string = '';

  @Ref avlType?: number;

  // Latest known point.
  @Ref current?: IVehiclePosition;

  // Timestamp metadata from the inbound message.
  @Ref sentTime?: string;

  // Per-vehicle position history (ordered by timestamp ascending).
  @Ref positionHistory: IVehiclePosition[] = [];

  constructor(data?: Partial<VehiclePosition>) {
    assignOwnProperties(this, normalize(data ?? {}));
  }
}
